import { routePaths } from './route-paths';

export const Config = {
  routePaths: routePaths,
  apiUrl: 'https://api.viceversa.app/',
  apiVersion: 'api/v1/',
  urls: {
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=app.viceversa.mobile',
    iosStoreUrl: 'https://apps.apple.com/pl/app/viceversa/id1605183101',
    waiterGoogleStoreUrl: 'https://play.google.com/store/apps/details?id=app.viceversawaiter',
    waiterIosStoreUrl: 'https://apps.apple.com/pl/app/vvvendor/id1633978570',
    vvBlog: 'https://blog.viceversa.app/',
    vvInstagram: 'https://instagram.com/viceversa_app?igshid=YmMyMTA2M2Y=',
    vvFacebook: 'https://www.facebook.com/viceversaapp',
    vvTikTok: ''
  }
};
